export default "__VITE_ASSET__z7Dyffzy__"